import React, { useState } from 'react';
import Button from './Button';
import '../Styles/Buttons.css';

export default function ButtonContainer(props) {
 /* contents of props: 
    buttonTexts: array with text values
    colors: array with colors hex values
    buttonType: type of buttons (optional): can be 'filled' or 'empty'
    onClick: method for buttons, if different from default (optional) - MUST have 1 string parameter
    subtitleTexts: caption texts for the buttons (optional)
    minWidth: overrides min width
    maxWidth: sets the max-width for the overall container
  */

  const [clicked, setClicked] = useState(null); // holds string with clicked button text

  var maxWidth = props.buttonTexts.length > 1 ? props.buttonTexts.length * 22.5 : 100
  maxWidth = props.maxWidth ? props.maxWidth : maxWidth


  // function that serves as button callback function
  function buttonOnClick(clickedText) {
    //console.log("THE CLICKED TEXT: ", clickedText);
    if (clickedText === "Tap here to go to the voice task") {
      var startStoryTime = new Date().getTime();
      if (sessionStorage.getItem('startStory', startStoryTime) === 0 || sessionStorage.getItem('startStory', startStoryTime) === null) {
        sessionStorage.setItem('startStory', startStoryTime);
      }
      console.log("START VOICE TASK TIME !!!: " , sessionStorage.getItem('startStory'));
    }
    if (clickedText === "Tap here to begin the second symbol matching task" /*&& (sessionStorage.getItem("timeSymMatch1") != 0 || sessionStorage.getItem("timeSymMatch1") != null) */) {
      // Second Symbol matching
      var startSymbolTime2 = new Date().getTime();
      if (sessionStorage.getItem('startSymbol2', startSymbolTime2) === 0 || sessionStorage.getItem('startSymbol2', startSymbolTime2) === null) {
        sessionStorage.setItem('startSymbol2', startSymbolTime2);
      }
      console.log("start TIME FOR SYMBOL 2 !!, " , sessionStorage.getItem('startSymbol2'));
    }
    if (props.onClick) {
      props.onClick(clickedText)
    }
    setClicked(clickedText)
  }

  return (
    <div className='container' style={{maxWidth:`${maxWidth}`}}>
      {props.buttonTexts.map((button, index) => {
        // sets the type of the button, if specified earlier
        var buttonType = button === clicked ? 'filled' : 'empty'
        if (props.buttonType) {
          buttonType = props.buttonType
        }
        
        return <Button 
                  color={props.colors[index]} 
                  text={button} 
                  type={buttonType}
                  onClick={buttonOnClick}
                  subtitle={props.subtitleTexts ? props.subtitleTexts[index] : null}
                  minWidth={props.minWidth}
                  margin={props.margin}
                  key={index}
                />
      })}
    </div>
  );

}
